<template>
  <!--begin::Wrapper-->
  <div class="w-100">
    <!--begin::Input group-->
    <div class="fv-row">
      <div class="row">
        <!-- tipo documento -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">tipo de documento:</label>
          <Field
            name="tipo"
            v-slot="{ field }"
            v-model="formData.tipo_documento"
          >
            <select
              v-model="formData.tipo_documento"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              :disabled="haveData"
              :onchange="requiredDisabled(formData.tipo_documento)"
            >
              <option
                v-for="(list, key) in documentTypeList"
                :value="list.id_tipo_documento_identidad"
                :key="key"
              >
                {{ list.nombre_tipo_documento_identidad }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="tipo"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
          <!-- <span class="color" v-if="v$.formData.nombre_juzgado.$error">
            El nombre del juzgado es requerido.
          </span> -->
        </div>
        <!-- número documento -->
        <div class="col-md-3 mt-3">
          <label class="form-label required">Número de documento:</label>
          <Field
            name="numero_documento"
            v-slot="{ field }"
            v-model="formData.numero_documento"
          >
            <input
              v-bind="field"
              class="form-control fuente"
              style="text-transform: uppercase"
              id="numero_doc"
              :disabled="
                !formData.tipo_documento ||
                haveData ||
                //debe ser el id_tipo_documento_identidad que su nombre_tipo_documento_identidad  es NO PORTA
                formData.tipo_documento == 4
              "
              @keyup.enter="checkExistenceOrGetDataSegip('partial')"              
            />
          </Field>
          <ErrorMessage
            name="numero_documento"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- complemento -->
        <div class="col-md-2 mt-3">
          <label class="form-label">Complemento:</label>
          <Field
            name="complemento"
            v-slot="{ field }"
            v-model="formData.complemento"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="complemento"
              style="text-transform: uppercase"
              v-model="formData.complemento"
              :disabled="
                !formData.numero_documento ||
                formData.tipo_documento != 1 ||
                haveData
              "
            />
          </Field>
        </div>
        <!-- boton buscar y borrar -->
        <div class="col-md-3 col-sm-12 mt-5 text-center">
          <button
            type="button"
            style="margin: 5px"
            class="btn px-3"
            :disabled="
              formData.tipo_documento != 1 ||
              !formData.numero_documento ||
              haveData
            "
            @click="checkExistenceOrGetDataSegip('partial')"
          >
            <i
              title="Realizar búsqueda"
              style="font-size: 1.5em; color: Dodgerblue"
              class="fas fa-magnifying-glass"
            ></i>
          </button>
          <button
            type="button"
            style="margin: 10px"
            class="btn px-3"
            @click="resetformData()"
          >
            <i
              title="Vaciar campos"
              style="font-size: 1.5em; color: red"
              class="fas fa-trash"
            ></i>
          </button>
        </div>
      </div>
      <!-- foto segip -->
      <div class="col-md-12 text-center">
        <Field
          name="fotografia"
          v-slot="{ field }"
          v-model="formData.fotografia"
        >
          <img
            v-bind="field"
            src="../../../../public/media/blank.png"
            class="img-fluid img-thumbnail"
            width="150"
            height="150"
            alt="without_image"
            v-if="!formData.fotografia || formData.fotografia === 'null'"
          />
          <img
            v-else
            :src="formData.fotografia"
            class="img-fluid img-thumbnail"
            width="150"
            height="150"
            alt="SegipImage"
          />
        </Field>
      </div>
      <br />
      <div class="row">
        <!-- nombres -->
        <div class="col-md-4 mt-3">
          <label class="form-label required" required>Nombres:</label>
          <Field
            name="nombres"
            v-slot="{ field }"
            v-model.trim="formData.nombres"
          >
            <input
              v-model.trim="formData.nombres"
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="nombres"
              style="text-transform: uppercase"
              :disabled="haveData"
            />
          </Field>
          <ErrorMessage
            name="nombres"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- apellido paterno -->
        <div class="col-md-4 mt-3">
          <label class="form-label">Apellido paterno:</label>
          <Field
            name="primerApellido"
            v-slot="{ field }"
            v-model.trim="formData.primerApellido"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="p_apellido"
              style="text-transform: uppercase"
              v-model.trim="formData.primerApellido"
              :disabled="haveData"
            />
          </Field>
        </div>
        <!-- apellido materno -->
        <div class="col-md-4 mt-3">
          <label class="form-label required" required>Apellido materno:</label>
          <Field
            name="segundoApellido"
            v-slot="{ field }"
            v-model.trim="formData.segundoApellido"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="s_apellido"
              style="text-transform: uppercase"
              v-model.trim="formData.segundoApellido"
              :disabled="haveData"
            />
          </Field>
          <ErrorMessage
            name="segundoApellido"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- fecha de nacimiento -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Fecha de nacimiento:</label>
          <Field
            name="fecha_nacimiento"
            v-slot="{ field }"
            v-model="formData.fechaNacimiento"
          >
            <Datepicker
              v-bind="field"
              v-model="formData.fechaNacimiento"
              uid="f_nac"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :maxDate="maxDate"
              :enableTimePicker="false"
              :format="format"
              :previewFormat="format"
              required
              :disabled="haveData"
              @update:modelValue="age(formData.fechaNacimiento)"
            ></Datepicker>
          </Field>
          <ErrorMessage
            name="fecha_nacimiento"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- edad -->
        <div class="col-md-4 mt-3">
          <label class="form-label">Edad:</label>
          <input
            type="text"
            class="form-control fuente"
            id="edad"
            :value="actualAge"
            readonly
          />
        </div>
        <!-- genero -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Género:</label>
          <Field name="genero" v-slot="{ field }" v-model="formData.genero">
            <select
              v-bind="field"
              class="form-select fuente"
              aria-label="select"
              :disabled="haveData"
            >
              <option value="MASCULINO">MASCULINO</option>
              <option value="FEMENINO">FEMENINO</option>
            </select>
          </Field>
          <ErrorMessage
            name="genero"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- pais -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">País:</label>
          <Field
            name="pais"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoPais"
          >
            <select
              v-model.trim="formData.lugarNacimientoPais"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              :disabled="haveData"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in countriesOrdered"
                :value="list.name"
                :key="key"
              >
                {{ list.name }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="pais"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- departamento -->
        <div
          v-if="formData.lugarNacimientoPais != 'BOLIVIA'"
          class="col-md-4 mt-3"
        >
          <label class="form-label required">Departamento/Ciudad:</label>
          <Field
            name="departamento"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoDepartamento"
          >
            <input
              v-bind="field"
              v-model.trim="formData.lugarNacimientoDepartamento"
              type="text"
              class="form-control fuente"
              id="departamento"
              style="text-transform: uppercase"
              :disabled="haveData"
            />
          </Field>
          <ErrorMessage
            name="departamento"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <div v-else class="col-md-4 mt-3">
          <label class="form-label">Departamento/Ciudad:</label>
          <Field
            name="departamento"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoDepartamento"
          >
            <select
              v-model.trim="formData.lugarNacimientoDepartamento"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              :disabled="haveData"
              style="text-transform: uppercase"
              :onchange="nameProvince(formData.lugarNacimientoDepartamento)"
            >
              <option
                v-for="(list, key) in departamentsList"
                :value="list.departamento"
                :key="key"
              >
                {{ list.departamento }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="departamento"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- provincia -->
        <div
          v-if="formData.lugarNacimientoPais != 'BOLIVIA'"
          class="col-md-4 mt-3"
        >
          <label class="form-label">Localidad/Provincia:</label>
          <Field
            name="provincia"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoProvincia"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="Provincia"
              style="text-transform: uppercase"
              v-model.trim="formData.lugarNacimientoProvincia"
              :disabled="haveData"
            />
          </Field>
        </div>
        <div v-else class="col-md-4 mt-3">
          <label class="form-label">Localidad/Provincia:</label>
          <Field
            name="provincia"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoProvincia"
          >
            <select
              v-model.trim="formData.lugarNacimientoProvincia"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              :disabled="haveData"
              style="text-transform: uppercase"
              :onchange="nameMunicipality(formData.lugarNacimientoProvincia)"
            >
              <option
                v-for="(list, key) in provincesList"
                :value="list.provincia"
                :key="key"
              >
                {{ list.provincia }}
              </option>
            </select>
          </Field>
        </div>
        <!-- municipio -->
        <div
          v-if="formData.lugarNacimientoPais != 'BOLIVIA'"
          class="col-md-4 mt-3"
        >
          <label class="form-label">Municipio:</label>
          <Field
            name="municipio"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoMunicipio"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="Municipio"
              style="text-transform: uppercase"
              v-model.trim="formData.lugarNacimientoMunicipio"
              :disabled="haveData"
            />
          </Field>
        </div>
        <div v-else class="col-md-4 mt-3">
          <label class="form-label">Municipio:</label>
          <Field
            name="municipio"
            v-slot="{ field }"
            v-model.trim="formData.lugarNacimientoMunicipio"
          >
            <select
              v-model.trim="formData.lugarNacimientoMunicipio"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              :disabled="haveData"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in municipalitiesList"
                :value="list.municipio"
                :key="key"
              >
                {{ list.municipio }}
              </option>
            </select>
          </Field>
        </div>
        <!-- domicilio -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Domicilio:</label>
          <Field
            name="domicilio"
            v-slot="{ field }"
            v-model.trim="formData.domicilio"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="direccion"
              style="text-transform: uppercase"
              :disabled="haveData"
            />
          </Field>
          <ErrorMessage
            name="domicilio"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- número de telefono -->
        <div class="col-md-4 mt-3">
          <label class="form-label">Número telefono fijo:</label>
          <Field
            name="telefonoFijo"
            v-slot="{ field }"
            v-model="formData.telefonoFijo"
          >
            <input
              v-bind="field"
              type="number"
              class="form-control fuente"
              id="telefono"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model="formData.telefonoFijo"
            />
          </Field>
        </div>
        <!-- número de celular -->
        <div class="col-md-4 mt-3">
          <label class="form-label">Número telefono celular:</label>
          <Field
            name="telefonoCelular"
            v-slot="{ field }"
            v-model="formData.telefonoCelular"
          >
            <input
              v-bind="field"
              type="number"
              class="form-control fuente"
              id="telefonoCelular"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model="formData.telefonoCelular"
            />
          </Field>
        </div>
        <!-- observaciones -->
        <div class="col-md-8 mt-3">
          <label class="form-label">Observaciones:</label>
          <Field
            name="observacionPersona"
            v-slot="{ field }"
            v-model="formData.observacionPersona"
          >
            <textarea
              v-bind="field"
              class="form-control fuente"
              id="telefonoCelular"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model="formData.observacionPersona"
            />
          </Field>
        </div>
      </div>
      <loading
        v-model:active="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        :height="100"
        :width="100"
      />
    </div>
  </div>
  <!--end::Wrapper-->
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  inject,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
//import vSelect from "vue-select";
//import "vue-select/dist/vue-select.css";
import date from "date-and-time";
import es from "date-and-time/locale/es";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import filiation from "@/filiation/composables/useFiliation";
import formatDate from "@/helpers/formatDate";
import countries from "@/core/data/countries";
import { Field, ErrorMessage } from "vee-validate";
import { subYears } from "date-fns";
import { useRoute, useRouter } from "vue-router";
import personImg from "@/assets/person.png";
export default defineComponent({
  name: "personData",
  components: {
    //vSelect,
    Datepicker,
    Field,
    ErrorMessage,
    Loading,
  },
  setup() {
    const maxDate = subYears(new Date(), 17);
    const isLoading = ref(false);
    const haveData = ref(false);
    const shownumberDoc = ref(false);
    const segipToken = ref(null);
    const router = useRouter();
    const route = useRoute();
    date.locale(es);
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
    const documentTypeList = ref([]);
    const actualAge = ref("");
    const departamentsList = ref([]);
    const provincesList = ref([]);
    const municipalitiesList = ref([]);
    const formData = reactive({
      tipo_documento: "",
      shownumberDoc: false,
      numero_documento: "",
      complemento: "",
      fotografia: "",
      nombres: "",
      primerApellido: "",
      segundoApellido: "",
      fechaNacimiento: "",
      genero: "",
      lugarNacimientoPais: "",
      lugarNacimientoDepartamento: "",
      lugarNacimientoProvincia: "",
      lugarNacimientoMunicipio: "",
      domicilio: "",
      telefonoFijo: "",
      telefonoCelular: "",
      observacionPersona: "",
      esReingreso: false,
    });
    const {
      documentType,
      nameDepartaments,
      nameProvinces,
      nameMunicipalities,
      checkData,
      dataToEdit,
      personalData,
    } = filiation();
    const emitter = inject("emitter");

    emitter.on("checkIfExist", async (value) => {
      if (value) {
        await personalData(formData);
      }
    });
    const listDocumentTypes = async () => {
      const { data } = await documentType();
      const result = data.filter(
        (tipo) =>
          tipo.nombre_tipo_documento_identidad !== "CERTIFICADO DE NACIMIENTO" &&
          tipo.nombre_tipo_documento_identidad !== "CERTIFICADO DE NACIDO VIVO"
      );
      documentTypeList.value = result;
    };
    const format = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const birthDate = (date) => {
      if (date !== undefined) {
        let format = date.split("/");
        let lastFormat = format[2] + "-" + format[1] + "-" + format[0];
        lastFormat = new Date(lastFormat + "T04:00:00Z");
        return lastFormat;
      }
      return "";
    };
    // const capitalize = (str) => {
    //   const lower = str.toLowerCase();
    //   return str.charAt(0).toUpperCase() + lower.slice(1);
    // };
    const age = (birthDay) => {
      const pattern = date.compile("DD/MM/YYYY");
      const dateConvert = date.format(birthDay, pattern);
      const currentDate = date.transform(
        dateConvert,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );
      const finalDate = parseInt(
        (new Date() - new Date(currentDate)) / (365 * 24 * 60 * 60 * 1000)
      );

      return (actualAge.value = finalDate + " años \n");
    };
    const nameDepartament = async () => {
      const { data } = await nameDepartaments();
      departamentsList.value = data;
    };
    const nameProvince = async (id) => {
      if (id === "") {
        return;
      } else {
        const { data } = await nameProvinces(id);
        provincesList.value = data;
      }
    };
    const nameMunicipality = async (prov) => {
      const dep = formData.lugarNacimientoDepartamento;
      const d = { dep, prov };
      if (prov === "") {
        return;
      } else {
        const { data } = await nameMunicipalities(d);
        municipalitiesList.value = data;
      }
    };
    const checkExistenceOrGetDataSegip = async (type) => {
      try {
        isLoading.value = true;
        const payload =
        type === "complete"
          ? { token: segipToken.value }
          : formData;
        const resp = await checkData(payload, type);
        const data = resp;    
        if (data.respuesta === "Se encontró más de un registro") {
          Toast.fire({
            icon: "info",
            title: `${data.respuesta},<br> debe ingresar el complemento.`,
          });

          isLoading.value = false;
          return;
        }

        if (
          data.type === "partial" ||
          (data.data && data.data.type === "partial")
        ) {
          isLoading.value = false;

          segipToken.value = data.token;

          const respuesta = data.data || data;

          const nombres = respuesta.Nombres || "";
          const primerApellido = respuesta.PrimerApellido || "";
          const segundoApellido = respuesta.SegundoApellido || "";

          const confirmResult = await Swal.fire({
            title: "Confirmar identidad",
            html: `
              <div style="text-align:left">
                <p>¿La persona consultada es la correcta?</p>
                <hr>
                <p><b>Nombres:</b> ${nombres}</p>
                <p><b>Primer apellido:</b> ${primerApellido}</p>
                <p><b>Segundo apellido:</b> ${segundoApellido}</p>
              </div>
            `,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, es correcto",
            cancelButtonText: "No, cancelar",
            buttonsStyling: false,
            reverseButtons: true,
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-light-danger",
            },
          });

          if (confirmResult.isConfirmed) {
            await checkExistenceOrGetDataSegip("complete");
            return;
          }

          segipToken.value = null;

          Toast.fire({
            icon: "info",
            title: "Consulta cancelada por el usuario.",
          });

          resetformData();
          haveData.value = false;
          return;
        }

        const respuesta = data.data || data;

        if (respuesta.NumeroDocumento === undefined) {
          Toast.fire({
            icon: "error",
            title: "No se encontraron coincidencias.",
          });

          haveData.value = false;
          isLoading.value = false;
          resetformData();
          return;
        }

        Toast.fire({
          icon: "success",
          title: "Resultado obtenido satisfactoriamente.",
        });

        formData.numero_documento = respuesta.NumeroDocumento;
        formData.complemento =
          respuesta.ComplementoVisible !== "0" && respuesta.Complemento !== undefined
            ? respuesta.Complemento
            : "";

        formData.nombres = respuesta.Nombres;
        formData.primerApellido = respuesta.PrimerApellido;
        formData.segundoApellido = respuesta.SegundoApellido;
        formData.fechaNacimiento = birthDate(respuesta.FechaNacimiento);
        formData.lugarNacimientoPais = respuesta.LugarNacimientoPais;
        formData.lugarNacimientoDepartamento = respuesta.LugarNacimientoDepartamento;
        formData.lugarNacimientoProvincia =
          respuesta.LugarNacimientoProvincia
            ? respuesta.LugarNacimientoProvincia.replace(/[']+/g, "")
            : "";
        formData.lugarNacimientoMunicipio = respuesta.LugarNacimientoLocalidad;
        formData.fotografia =
          respuesta.Fotografia !== undefined && respuesta.Fotografia !== null
            ? "data:image/jpeg;base64," + respuesta.Fotografia
            : personImg;
        formData.domicilio = respuesta.Domicilio;
        formData.genero = respuesta.Genero;

        isLoading.value = false;
        haveData.value = true;

        age(new Date(formData.fechaNacimiento));

      } catch (error) {
        console.error(error);

        Toast.fire({
          icon: "error",
          title: "Ocurrió un error al consultar SEGIP.",
        });

        isLoading.value = false;
      }
    };
    const resetformData = async () => {
      formData.tipo_documento = "";
      formData.numero_documento = "";
      formData.complemento = "";
      formData.fotografia = "";
      formData.nombres = "";
      formData.primerApellido = "";
      formData.segundoApellido = "";
      formData.fechaNacimiento = "";
      formData.genero = "";
      formData.lugarNacimientoPais = "";
      formData.lugarNacimientoDepartamento = "";
      formData.lugarNacimientoProvincia = "";
      formData.lugarNacimientoMunicipio = "";
      formData.domicilio = "";
      formData.telefonoFijo = "";
      formData.telefonoCelular = "";
      formData.observacionPersona = "";
      actualAge.value = "";
      haveData.value = false;
    };
    const requiredDisabled = (tipo_documento) => {
      const found = documentTypeList.value.find(
        (element) => element.id_tipo_documento_identidad == tipo_documento
      );
      if (found === undefined) {
        return;
      } else {
        if (found.nombre_tipo_documento_identidad == "NO PORTA") {
          shownumberDoc.value = true;
        } else {
          shownumberDoc.value = false;
        }
      }
    };
    const checkReEntry = () => {
      console.log(formData);
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    const countriesOrdered = computed(() =>
      countries[0].result.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      })
    );
    onMounted(() => {
      setCurrentPageBreadcrumbs("Datos de la persona", [
        "Registro privado de libertad",
      ]);
      listDocumentTypes();
      nameDepartament();
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        haveData.value = false;
        const data = JSON.parse(localStorage.getItem("edit") || "{}");
        formData.tipo_documento = data.general[0].cod_tipo_documento_identidad;
        formData.numero_documento = data.general[0].nro_documento;
        formData.complemento = data.general[0].complemento;
        formData.fotografia = data.general[0].imagen_segip;
        formData.nombres = data.general[0].nombres;
        formData.primerApellido = data.general[0].primer_apellido;
        formData.segundoApellido = data.general[0].segundo_apellido;
        formData.fechaNacimiento = data.general[0].fecha_nacimiento;
        formData.genero = data.general[0].genero;
        formData.lugarNacimientoPais = data.general[0].pais;
        formData.lugarNacimientoDepartamento = data.general[0].departamento;
        formData.lugarNacimientoProvincia = data.general[0].provincia;
        formData.lugarNacimientoMunicipio = data.general[0].localidad;
        formData.domicilio = data.general[0].direccion;
        formData.telefonoFijo = data.general[0].telefono_fijo;
        formData.telefonoCelular = data.general[0].telefono_movil;
        formData.observacionPersona = data.general[0].obs_persona;
        age(new Date(formData.fechaNacimiento));
      }
    });
    return {
      maxDate,
      isLoading,
      haveData,
      shownumberDoc,
      formData,
      documentTypeList,
      actualAge,
      countriesOrdered,
      departamentsList,
      provincesList,
      municipalitiesList,
      dataEdit,
      checkReEntry,
      checkExistenceOrGetDataSegip,
      format,
      age,
      birthDate,
      nameDepartament,
      nameProvince,
      nameMunicipality,
      resetformData,
      requiredDisabled,
    };
  },
  emits: ["updateBtn"],
});
</script>
<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
textarea {
  width: 200px;
  height: 80px;
}
</style>
